const Countries = [
  { code: "IN", label: "India" },
  { code: "AE", label: "United Arab Emirates" },
  { code: "KW", label: "Kuwait" },
  { code: "SA", label: "Saudi Arabia" },
  { code: "UK", label: "United Kingdom" },
  { code: "QA", label: "Qatar" },
  { code: "BH", label: "Bahrain" },
  { code: "OM", label: "Oman" },
];

export default Countries;
